import React from "react";
import useLightwindow from "../../../../../../common/hooks/useLightwindow";

interface ICashbackSpecialOffer {
    amount: number;
}

const CashbackSpecialOffer: React.FC<ICashbackSpecialOffer> = (props) => {
    const { openCashbackModal } = useLightwindow();

    return (
        <a onClick={openCashbackModal}>{`Your cashback $${props.amount.toFixed(2)}`}</a>
    );
};

export default CashbackSpecialOffer;
